import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { OptInGetRes, OptInUpdateReq, OptInUpdateRes } from '../feature-modules/opt-in/models/opt-in.model';
import { catchError, map, tap, timeout } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Store } from '@ngrx/store';
import { updateOptInSuccess } from '../feature-modules/opt-in/store/opt-in.actions';

@Injectable({
  providedIn: 'root',
})
export class OptInService {
  constructor(
    private readonly httpClient: HttpClient,
    private readonly cookieService: CookieService,
    private readonly store: Store
  ) {}
  getOptIn() {
    return this.httpClient
      .get<OptInGetRes>(`${environment.cswCustomerService}/optin`, {
        headers: { Authorization: this.cookieService.get('X-Access-Token') },
      })
      .pipe(
        timeout(30000), // Set timeout to 30 seconds
        catchError((error) => {
          if (error.name === 'TimeoutError') {
            // Handle timeout error
            console.error('Request timed out');
            return throwError('The request took too long and timed out.');
          }
          // Handle other errors
          return throwError(error);
        })
      );
  }

  updateOptIn(req: OptInUpdateReq) {
    return this.httpClient
      .put<OptInUpdateRes>(`${environment.cswCustomerService}/optin`, req, {
        headers: { Authorization: this.cookieService.get('X-Access-Token') },
      })
      .pipe(
        map((res) => {
          if (res.status === 'failure') {
            throw throwError(() => new Error('Update error.'));
          }
          return req;
        }),
        tap((response) => this.store.dispatch(updateOptInSuccess({ response })))
      );
  }

  dismissPaperlessInterstitialPage() {
    return this.updateOptIn([{ featureType: 'PAPERLESS_INTERSTITIAL', optedIn: true }]);
  }
  dismissPaperlessBanner() {
    return this.updateOptIn([{ featureType: 'PAPERLESS_BANNER', optedIn: true }]);
  }

  acceptOptIn() {
    return this.httpClient.post(
      `${environment.customerGateway}/credit-profile-opt-in`,
      {
        optInForPersonalizedOffers: true,
        disclosureName: 'CREDIT_PROFILE_AUTHORIZATION',
      },
      { headers: { Authorization: this.cookieService.get('X-Access-Token') } }
    );
  }
}
